export const selectForm = state => state.form;

export const selectSupervisor = state => state.form.supervisor;

export const selectEngineer = state => state.form.engineer;

export const selectRoute = state => state.form.route;

export const selectDocumentDate = state => state.form.documentDate;

export const selectExpiredDate = state => state.form.expiredDate;

export const selectCheckedDate = state => state.form.checkedDate;

export const selectDocumentNumber = state => state.form.documentNumber;

export const selectDutyNumber = state => state.form.dutyNumber;

export const selectMilitaryUnit = state => state.form.militaryUnit;

export const selectCar = state => state.form.car;

export const selectFormal = state => state.form.formal;

export const selectExpenses = state => state.form.expenses;

export const selectFacts = state => state.form.facts;

export const selectRoutes = state => state.form.routes;

export const selectTotalMileage = state => state.form.totalMileage;

export const selectTotalExpense = state => state.form.totalExpense;

export const selectCheckPerson = state => state.form.checkPerson;
